"use client";

import { usePathname, useRouter } from "next/navigation";
import { useEffect } from "react";
import { toast } from "sonner";
import { usePartnerInfo } from "@/hooks/use-partner-info";

/** Routes an expired partner may still reach, so they can pay to un-expire. */
const ALLOWED_WHEN_EXPIRED = ["/cazhbox", "/account", "/profile", "/auth"];

/**
 * Package/status gate, ported from v1 layouts/DefaultLayout.js loadData():
 * an expired package is redirected to /account, and a partner whose account is
 * no longer active is signed out.
 */
export function EntitlementGuard() {
	const { isExpiredPackage, isLoading } = usePartnerInfo();
	const pathname = usePathname();
	const router = useRouter();

	useEffect(() => {
		if (isLoading || !isExpiredPackage) return;
		if (ALLOWED_WHEN_EXPIRED.some((p) => pathname.startsWith(p))) return;
		toast.error("Paket Anda telah berakhir. Perpanjang untuk melanjutkan.");
		router.replace("/account");
	}, [isExpiredPackage, isLoading, pathname, router]);

	return null;
}

export default EntitlementGuard;
